function IconEmailPink() {
    return (
        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.8 0.725464H1.2C0.54 0.725464 0.00599999 1.17988 0.00599999 1.73527L0 7.79409C0 8.34948 0.54 8.80389 1.2 8.80389H10.8C11.46 8.80389 12 8.34948 12 7.79409V1.73527C12 1.17988 11.46 0.725464 10.8 0.725464ZM10.8 7.79409H1.2V2.74507L6 5.26958L10.8 2.74507V7.79409ZM6 4.25978L1.2 1.73527H10.8L6 4.25978Z" fill="#D74DED" />
        </svg>
    )
}
export default IconEmailPink;